import {Static} from '../services/api'

import {GET_DEPARTMENTS,RESET_DEPARTMENTS, GET_DEPARTMENTS_ERROR} from '../redux/reducers/departments'
import {GET_COURTS,RESET_COURTS, GET_COURTS_ERROR} from '../redux/reducers/courts'


export const getStates = () => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.states();
            return dispatch({type: 'GET_STATES', payload})
        } catch (e) {
            return dispatch({type: 'GET_STATES_ERROR', payload: e})
        }
    }
};

export const getCounties = (stateId:number) => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.counties(stateId);
            return dispatch({type: 'GET_COUNTIES', payload})
        } catch (e) {
            return dispatch({type: 'GET_COUNTIES_ERROR', payload: e})
        }
    }
};

export const resetCounties = () => {
    return async (dispatch: any) => {
        return dispatch({type: 'RESET_COUNTIES'})
    }
};

export const getCourts = (countyId:number) => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.courts(countyId);
            return dispatch({type: GET_COURTS, payload})
        } catch (e) {
            return dispatch({type: GET_COURTS_ERROR, payload: e})
        }
    }
};

export const resetCourts = () => {
    return (dispatch: any) => {
        dispatch({type: RESET_COURTS})
    }
};

export const getDepartments = (courtId:number) => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.departments(courtId);
            return dispatch({type: GET_DEPARTMENTS, payload})
        } catch (e) {
            return dispatch({type: GET_DEPARTMENTS_ERROR, payload: e})
        }
    }
};

export const resetDepartments = () => {
    return(dispatch: any) => {
        return dispatch({type: RESET_DEPARTMENTS})
    }
};

export const getCaseTypes = () => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.caseTypes();
            return dispatch({type: 'GET_CASE_TYPES', payload})
        } catch (e) {
            return dispatch({type: 'GET_CASE_TYPES_ERROR', payload: e})
        }
    }
};

export const getCaseSubTypes = (caseTypeId:number) => {
    return async (dispatch: any) => {
        try {
            const payload = await Static.caseSubTypes(caseTypeId);
            return dispatch({type: 'GET_CASE_SUB_TYPES', payload})
        } catch (e) {
            return dispatch({type: 'GET_CASE_SUB_ERROR', payload: e})
        }
    }
};

export const resetCaseSubTypes = () => {
    return async (dispatch: any) => {
        return dispatch({type: 'RESET_CASE_SUB_TYPES'})
    }
};
